var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMpShopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 10.1875V8.25C21.75 3.9766 18.2733 0.5 14 0.5C9.7266 0.5 6.25 3.9766 6.25 8.25V10.1875H0.4375V26.6562C0.4375 29.3314 2.60611 31.5 5.28125 31.5H22.7188C25.3939 31.5 27.5625 29.3314 27.5625 26.6562V10.1875H21.75ZM10.125 8.25C10.125 6.1133 11.8633 4.375 14 4.375C16.1367 4.375 17.875 6.1133 17.875 8.25V10.1875H10.125V8.25ZM19.8125 15.5156C19.01 15.5156 18.3594 14.865 18.3594 14.0625C18.3594 13.26 19.01 12.6094 19.8125 12.6094C20.615 12.6094 21.2656 13.26 21.2656 14.0625C21.2656 14.865 20.615 15.5156 19.8125 15.5156ZM8.1875 15.5156C7.38495 15.5156 6.73438 14.865 6.73438 14.0625C6.73438 13.26 7.38495 12.6094 8.1875 12.6094C8.99005 12.6094 9.64062 13.26 9.64062 14.0625C9.64062 14.865 8.99005 15.5156 8.1875 15.5156Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpShopIcon);
export default __webpack_public_path__ + "static/media/mp-shop-icon.1e4ceb135d25e74a338342204538bbf2.svg";
export { ForwardRef as ReactComponent };